export default __webpack_public_path__ + "static/media/web_banner_onboarding.79e24f5f.png";